// Action creators extracted from ClassRoomModule.js

import _ from "lodash";
import {
  INIT_FILTERS,
  UPDATE_FILTERS,
  UPDATE_COURSE_ID,
  UPDATE_TODO_FILTERS,
  SET_COURSE_ID,
  SET_PDFTRON_INSTANCE,
  UPDATE_CLASSROOM_FILTERS,
  SET_CURRICULUM_PROGRAM,
  SET_SHOULD_NAVIGATE_TO_FIRST_STUDENT_ASSIGNMENT,
  SET_ALL_SUBMISSIONS_SCROLL_POSITION,
  SET_AI_EVALUATION_STATUS,
  RESET_AI_EVALUATION_STATUS,
  UPDATE_HIGHLIGH_TASK_ID,
  SET_AI_CONVERSATION_ANALYSING_STATUS,
  UPDATE_AI_DATA,
  UPDATE_EVALUATION_DATA,
  SET_COURSE_FLOW_RESOURCE_DATA_FOR_REFETCH,
  SET_AI_GRADING_PROGRESS,
  UPDATE_STUDENT_ASSIGNMENT_LINK_SHORT_URLS_MAPPING,
  SET_ELEMENT_RATING_MUTATION_IN_PROGRESS,
} from "./ClassRoomConstants";

// Action Creators
export const updateFilters = data => {
  return {
    type: UPDATE_FILTERS,
    data,
  };
};

export const updateTodoFilters = data => {
  return {
    type: UPDATE_TODO_FILTERS,
    data,
  };
};

export const updateHighlightTaskId = data => {
  return {
    type: UPDATE_HIGHLIGH_TASK_ID,
    data,
  };
};

export const setPdftronInstance = data => {
  return {
    type: SET_PDFTRON_INSTANCE,
    payload: _.get(data, "instance", null),
  };
};

export const updateAIData = data => {
  return {
    type: UPDATE_AI_DATA,
    data,
  };
};

export const updateEvaluationData = data => {
  return {
    type: UPDATE_EVALUATION_DATA,
    data,
  };
};

export const setCourseFlowResourceDataForRefetch = data => {
  return {
    type: SET_COURSE_FLOW_RESOURCE_DATA_FOR_REFETCH,
    data,
  };
};

export const setElementRatingMutationInProgress = data => {
  return {
    type: SET_ELEMENT_RATING_MUTATION_IN_PROGRESS,
    data,
  };
};

export const initFilters = () => {
  return {
    type: INIT_FILTERS,
  };
};

export const updateCourseId = courseId => {
  return {
    type: UPDATE_COURSE_ID,
    payload: courseId,
  };
};

export const setCurriculumProgram = curriculumProgram => {
  return {
    type: SET_CURRICULUM_PROGRAM,
    payload: curriculumProgram,
  };
};

export const updateClassRoomFilters = data => {
  return {
    type: UPDATE_CLASSROOM_FILTERS,
    data,
  };
};

export const setShouldNavigateToFirstStudentAssignment = data => {
  return {
    type: SET_SHOULD_NAVIGATE_TO_FIRST_STUDENT_ASSIGNMENT,
    data,
  };
};

export const setAllSubmissionsScrollPosition = data => {
  return {
    type: SET_ALL_SUBMISSIONS_SCROLL_POSITION,
    data,
  };
};

export const setAIConversationAnalysingStatus = data => {
  return {
    type: SET_AI_CONVERSATION_ANALYSING_STATUS,
    data,
  };
};

export const setAIEvaluationStatus = data => {
  return {
    type: SET_AI_EVALUATION_STATUS,
    data,
  };
};

export const resetAIEvaluationStatus = () => {
  return {
    type: RESET_AI_EVALUATION_STATUS,
  };
};

export const setAIGradingProgress = data => {
  return {
    type: SET_AI_GRADING_PROGRESS,
    data,
  };
};

//create action creator for studentAssignmentLinkShortUrlsMapping
export const updateStudentAssignmentLinkShortUrlsMapping = data => {
  return {
    type: UPDATE_STUDENT_ASSIGNMENT_LINK_SHORT_URLS_MAPPING,
    data,
  };
};

export const setCourseId = value => {
  return { type: SET_COURSE_ID, payload: value };
};
